import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/service/auth.service';
import { UserProfileService } from 'src/app/service/user-profile.service';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  email: string;
  loginForm: FormGroup;

  constructor(
    public authService: AuthService,
    private userProfileService: UserProfileService,
    private messageService: MessageService,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.buildLoginForm();
  }

  buildLoginForm() {
    this.loginForm = this.fb.group({
      email: ''
    });

  }

  // convenience getter for easy access to form fields
  get loginControls() { return this.loginForm.controls; }

  sendResetLink() {
    this.email = this.loginControls.email.value;

    this.userProfileService.getUIDfromEmail(this.email)
      .then(uid => {
        this.authService.sendPasswordResetEmail(this.email);
      })
      .catch(err => {
        this.messageService.clear();
        this.messageService.add({ key: 'info', severity: 'error', summary: 'Failed.', detail: 'No User exists with this email.' });
      });
  }
}
